import { render } from "./link-feedback-popup.vue?vue&type=template&id=a94db848&scoped=true"
import script from "./link-feedback-popup.vue?vue&type=script&lang=js"
export * from "./link-feedback-popup.vue?vue&type=script&lang=js"

import "./link-feedback-popup.vue?vue&type=style&index=0&id=a94db848&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a94db848"]])

export default __exports__